import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=5d6cf04e&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=5d6cf04e&prod&lang=css&"
import style1 from "./notice.vue?vue&type=style&index=1&id=5d6cf04e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6cf04e",
  null
  
)

export default component.exports